import 'moment';
import { cloneDeep } from 'lodash';

class SelectEventController {

    constructor($scope, basket, availabilityApiService, eventsService, addGuestService, dateService, availabilityService, itemService, loadingService) {
        this.$scope = $scope;
        this.basket = basket;
        this.availabilityApiService = availabilityApiService;
        this.eventsService = eventsService;
        this.addGuestService = addGuestService;
        this.dateService = dateService;
        this.availabilityService = availabilityService;
        this.itemService = itemService;
        this.loadingService = loadingService;
    }

    $onInit () {
        this.watchSelectedEvent();
    }

    groupEvents (item) {
        return item.type_display;
    }

    filter (param) {
        switch (param) {
            case 'treatments':
                this.eventFilters.treatments = !this.eventFilters.treatments;
                break;
            case 'spadays':
                this.eventFilters.spaDays = !this.eventFilters.spaDays;
                break;
            case 'activities':
                this.eventFilters.activities = !this.eventFilters.activities;
                break;
        }

        this.filterEvents();
    }

    placeholder () {
        if (this.loadingService.isLoading('events')) {
            return 'Loading...';
        }

        let string = 'Search';
        let types = [];

        if (this.activeEvents.treatments) {
            types.push('Treatments');
        }

        if (this.activeEvents.spaDays) {
            types.push('Spa Days');
        }

        if (this.activeEvents.activities) {
            types.push('Activities');
        }

        return `${string} ${types.join(' and ')}...`;
    }

    selectEvent (event) {
        if (!event) {
            return false;
        }
        this.resetAvailability({ resetEvent: false, resetGuests: false });

        this.loadingService.startLoading('availability');

        let item = cloneDeep(event);
        item.preferred_time = undefined;
        item.date = this.dateService.checkStoredDate();

        this.itemService.setItem(item);

        this.basket.contents.guest_details.map((guest) => {
            guest.disabled = false;

            return guest;
        });

        this.addGuestService.setState({
            existingGuests: this.basket.contents.guest_details,
            gender: item.gender,
            maximumGuests: item.maximum_guests,
            minimumGuests: item.minimum_guests,
            guests: []
        });

        return Promise.all([
            this.getCustomisations(),
            this.getAvailability(item)
        ]);
    }

    clearEvent ($event, $select) {
        $event.stopPropagation();
        $select.selected = '';
        $select.search = null;

        this.resetAvailability({ resetEvent: true, resetGuests: true });
    }

    getAvailability (item) {
        const toDate = moment(item.date).add(6, 'days').format('YYYY-MM-DD');

        return this.availabilityApiService.requestAvailability(item.date, toDate, item.type_name, item.id, item.offer)
            .then(response => {
                this.loadingService.stopLoading('availability');
                this.availabilityService.setAvailability(response);
            });
    }

    getCustomisations () {
        this.customisations = null;

        return new Promise(resolve => {
            const item = this.itemService.getItem();
            if (item) {
                this.loadingService.startLoading('customise');

                return this.eventsService.collectCustomisations(item.type_name, item.id)
                    .then(response => {
                        this.loadingService.stopLoading('customise');
                        this.customisations = response;

                        resolve();
                    });
            }

            resolve();
        });
    }

    watchSelectedEvent () {
        this.$scope.$watch(() => this.selectedEvent, (newVal, oldVal) => {
            if (newVal && typeof newVal === 'object') {
                this.selectEvent(newVal);
            }
        }, true);
    }
}

SelectEventController.$inject = ['$scope', 'basket', 'availabilityApiService', 'eventsService', 'addGuestService', 'dateService', 'availabilityService', 'itemService', 'loadingService'];

export default SelectEventController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/basket/controllers/select.event.controller.js